import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  root: {
    padding: "8px",
  },
}));
